import { useFocusRing } from '@react-aria/focus';
import { getInteractionModality } from '@react-aria/interactions';
export const usePatchedFocusRing = (props) => {
    const focusRing = useFocusRing(props);
    // Hack to avoid isFocusVisible=true after page refhresh / window focus
    const modality = getInteractionModality();
    const isKeyboardModality = modality === 'keyboard';
    return {
        ...focusRing,
        isFocusVisible: isKeyboardModality && focusRing.isFocusVisible,
    };
};
